import React from "react"
import "./Toolbar.scss"

export default function Toolbar (props) {	
	const { children } = props
	return <div className="Toolbar">
		{ children }
	</div>
}